module.exports = __webpack_public_path__ + "img/indebg.3504efe3.png";